<template>
    <div>
        <vs-tabs class="unique_cstm_tab">
            <vs-tab label="Email">
                <Email></Email>
            </vs-tab>
            <vs-tab  label="Email Template">
                <EmailTemplate></EmailTemplate>
            </vs-tab>
             <vs-tab label="Email Signature">
                <EmailSignature />
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>
import Email from './email.vue'
import EmailTemplate from './emailTemplate.vue'
import EmailSignature from './emailSignature.vue'
import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'

export default {
  name: 'email',
  mixins:[PermissionMiddleware],
  components: {
    Email,
    EmailTemplate,
    EmailSignature
  },
  data () {
    return {
      schoolAdmin: null
    }
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Communication', 'email')
    }
  }
}
</script>